/* ===========================================================================
   IMAGE SOURCES
   ---------------------------------------------------------------------------
   Every image on the site resolves through this one file. To swap a photo,
   change the URL here and nothing else.
   =========================================================================== */

/** The real Vitality mark. Hosted by the Magic Patterns design system. */
export const LOGO =
  'https://cdn.magicpatterns.com/design-systems/ds-2db215f0-4f4c-4f63-99c7-6764a7e41c37/logos/3e29f530-9ace-4422-9a45-a1e55db4121c.png';

/** Leadership portraits. Square or portrait crops, faces in the upper third. */
export const PORTRAIT = {
  natalya: 'https://cdn.magicpatterns.com/uploads/tx82xy1DyHfCG3N3kde7xx/7_Natalya.jpg',
};

/** Vitality's own landscape photography. */
export const SCENE_IMG = {
  /** Granite peaks doubled in a still alpine lake. The hero: the terrain ahead. */
  windRiverLake: 'https://cdn.magicpatterns.com/uploads/wECkRf9bErYcP1SJXCNgzc/Wind_river_2.jpg',
  /** Mountains under a burning sunset. Behind the two doors. */
  sunsetRidge: 'https://cdn.magicpatterns.com/uploads/4BYTUpyrqnqBb5Pu4zdcbF/IMG_2578.jpg',
  /** Flat layered-ridge illustration: sky, snow peak, receding ranges, dark
      green foreground. The terrain section is built around it. */
  terrainIllustration:
    'https://cdn.magicpatterns.com/uploads/j5R17GzdH1dzyAPCb8W4tJ/AdobeStock_181685432.jpg',
  /** Alpine tundra groundcover over rock and lichen. */
  tundraSoil: 'https://cdn.magicpatterns.com/uploads/8c5tkB7YEqsQpe2CgDuvuX/IMG_2579.jpg',
  /** An aspen grove: many trunks, one connected organism. */
  aspenGrove: 'https://cdn.magicpatterns.com/uploads/eDmYxwm61L57u4zjsDbQo2/IMG_2640.jpg',
  /** A single backlit aspen leaf. */
  aspenLeaf: 'https://cdn.magicpatterns.com/uploads/dsCDSzBLbyvECkSMKBtpDb/IMG_2545.jpg',
};
